import React, { useMemo, useState } from 'react';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import { ButtonSortQuestionnaries } from '@/components/common/molecules';
import { useTranslation } from 'react-i18next';
import { ProductFilters, ProductList } from '@/components/common';
import { Form, Select } from 'antd';
import styled from 'styled-components';

export const TableProducts = ({ data, adminView = false }) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState('new');
  const [companyFilter, setCompanyFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);
  const [termFilter, setTermFilter] = useState(null);
  const [searchFilter, setSearchFilter] = useState('');

  const sortQuestionnariesTitle = [
    {
      value: 'new',
      label: t('NEW')
    },
    {
      value: 'passed',
      label: t('PASSED')
    },
    {
      value: 'inProgress',
      label: t('IN REVIEW')
    },
    {
      value: 'rejected',
      label: t('REJECTED')
    },
    {
      value: 'draft',
      label: t('DRAFT')
    },
    {
      value: 'needChecking',
      label: t('NEED CHECKING')
    }
  ];

  const handleSearchFilter = (value) => {
    setSearchFilter(value);
  };

  const handleChange = (value) => {
    setActiveTab(value);
  };

  const filteredProductList = useMemo(() => {
    if (data) {
      let productList = data[activeTab];

      if (companyFilter) {
        productList = productList.filter((item) =>
          item.company ? item.company.trim() === companyFilter.trim() : false
        );
      }

      if (termFilter) {
        productList = productList.filter((item) =>
          item.term ? item.term.trim() === termFilter.trim() : false
        );
      }

      if (typeFilter) {
        productList = productList.filter((item) =>
          item.type ? item.type.trim() === typeFilter : false
        );
      }

      if (searchFilter) {
        productList = productList.filter((item) =>
          item.title ? item.title.toLowerCase().includes(searchFilter.toLowerCase()) : false
        );
      }

      return productList;
    }

    return null;
  }, [data, activeTab, companyFilter, termFilter, typeFilter, searchFilter]);

  return (
    <>
      <Container $smdHidden>
        <Flex gap={24} $marginBottom={32} align={'center'} wrap>
          <ButtonSortQuestionnaries
            text={t('NEW')}
            amount={data.new && data.new.length > 0 && data?.new.length}
            active={activeTab === 'new'}
            onClick={() => setActiveTab('new')}
          />
          <ButtonSortQuestionnaries
            text={t('PASSED')}
            amount={data.passed && data.passed.length > 0 && data?.passed.length}
            active={activeTab === 'passed'}
            onClick={() => setActiveTab('passed')}
          />
          <ButtonSortQuestionnaries
            text={t('IN REVIEW')}
            amount={data.inProgress && data.inProgress.length > 0 && data?.inProgress.length}
            active={activeTab === 'inProgress'}
            onClick={() => setActiveTab('inProgress')}
          />

          <ButtonSortQuestionnaries
            text={t('REJECTED')}
            amount={data.rejected && data.rejected.length > 0 && data?.rejected.length}
            active={activeTab === 'rejected'}
            onClick={() => setActiveTab('rejected')}
          />
          <ButtonSortQuestionnaries
            text={t('NEED CHECKING')}
            amount={data.needChecking && data.needChecking.length > 0 && data?.needChecking.length}
            active={activeTab === 'needChecking'}
            onClick={() => setActiveTab('needChecking')}
          />
          <ButtonSortQuestionnaries
            text={t('DRAFT')}
            amount={data.draft && data.draft.length > 0 && data?.draft.length}
            active={activeTab === 'draft'}
            onClick={() => setActiveTab('draft')}
          />
        </Flex>
      </Container>

      <Flex vertical>
        <Container $hidden $smdVisible>
          <Form layout='vertical'>
            <Form.Item label={t('Sort by:')}>
              <StyledSelect
                options={sortQuestionnariesTitle}
                defaultValue={activeTab}
                onChange={handleChange}
              />
            </Form.Item>
          </Form>
        </Container>

        <ProductFilters
          data={data[activeTab]}
          setCompanyFilter={setCompanyFilter}
          setTermFilter={setTermFilter}
          setTypeFilter={setTypeFilter}
          handleSearchFilter={handleSearchFilter}
        />
      </Flex>

      <Container $marginTop={32}>
        <ProductList products={filteredProductList} adminView={adminView} />
      </Container>
    </>
  );
};

const StyledSelect = styled(Select)`
  width: 250px !important;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    width: 100% !important;
  }
`;
